// Extracts a user-facing message from an axios error, or returns undefined.
// Backend v2 errors look like { detail: { message, code, ...extra } }; specific codes may add `field`.
export function getErrorMessage(e) {
  const data = e && e.response && e.response.data
  if (!data) return undefined
  const detail = data.detail
  if (Array.isArray(detail)) {
    return detail.map(err => {
      const field = err.loc ? err.loc.join('.') : ''
      return field ? `${field}: ${err.msg}` : err.msg
    }).join('\n')
  }
  if (typeof detail === 'string') return detail
  if (detail && detail.message) {
    return detail.field ? `${detail.field}: ${detail.message}` : detail.message
  }
  return (data.error && data.error.message) || data.message
}

const parseError = {
  methods: {
    parseErrorMessage(e) {
      return getErrorMessage(e) || `Something went wrong: ${e}`
    }
  }
}

export default parseError
